<template>
  <link
    rel="stylesheet"
    type="text/css"
    href="//cdn.jsdelivr.net/gh/loadingio/ldbutton@v1.0.1/dist/ldbtn.min.css"
  />
  <link
    rel="stylesheet"
    type="text/css"
    href="https://cdn.jsdelivr.net/gh/loadingio/loading.css@v2.0.0/dist/loading.min.css"
  />

  <div class="mainContainer" v-if="loaded">
    <h1>{{ surveydata.title }}</h1>
    <div class="emailContainer">
      <h2
        :class="{
          emailLabel: true,
          requiredhighlight: showAllRequired && name === '',
        }"
      >
        Name
      </h2>
      <input type="text" v-model="name" placeholder="Your Name" />
      <h2
        :class="{
          emailLabel: true,
          requiredhighlight: showAllRequired && !emailValid,
        }"
      >
        Your Email Address
      </h2>
      <input
        type="email"
        id="email"
        v-model="email"
        placeholder="example@example.com"
        @change="checkEmail"
      />
      <h2
        :class="{
          emailLabel: true,
          requiredhighlight: showAllRequired && institution === '',
        }"
      >
        Institution / Organisation
      </h2>
      <input
        type="text"
        v-model="institution"
        placeholder="Institution / Organisation"
      />
    </div>
    <div v-for="q in surveydata.questions" :key="q.id">
      <Question
        :text="q.text"
        :options="q.scale.options"
        :ltext="q.scale.ltext"
        :ctext="q.scale.ctext"
        :rtext="q.scale.rtext"
        :id="q.id"
        :deselectable="q.deselectable"
        :showrequired="!q.deselectable && showAllRequired"
        :category="categoryData[q.categoryId]"
      />
    </div>

    <h6 class="codetext">{{ $route.params.code }}</h6>
    <button @click="handleSubmit"><h2>Submit</h2></button>
    <div class="ld-over-full-inverse running" v-if="submitted">
      <div class="ld ld-ring ld-spin"></div>
    </div>
    <h4 class="fillrequired" v-if="showAllRequired">
      Please fill in required questions
    </h4>
  </div>
  <div class="loadingContainer" v-else>
    <h1 :class="{ delayshow: true, doshow: showLoading, dohide: !showLoading }">
      Loading...
    </h1>
  </div>
</template>

<script>
import axios from "axios";
import { baseurl } from "../api";
import Question from "./Question.vue";
import pointsStore from "../pointsStore";
export default {
  name: "Survey",
  components: {
    Question: Question,
  },
  methods: {
    handleSubmit() {
      let filledReq = [];
      for (const q of this.surveydata.questions) {
        if (!q.deselectable) {
          filledReq.push(q.id);
        }
      }
      const isfilled = pointsStore.getFilled();
      this.checkEmail();
      if (
        filledReq.every((v) => isfilled.includes(v)) &&
        this.emailValid &&
        this.institution !== "" &&
        this.name != ""
      ) {
        this.submitted = true;
        pointsStore.sortResponses();
        const data = {
          code: this.$route.params.code,
          data: btoa(
            JSON.stringify({
              email: this.email,
              institution: this.institution,
              name: this.name,
              timestamp:
                new Date().toDateString() + " " + new Date().toTimeString(),
              responses: pointsStore.responses,
            })
          ),
        };
        axios.post(baseurl + "submit", data).then(() => {
          this.$router.push("/end");
        });
        return;
      }
      this.showAllRequired = true;
    },
    checkEmail() {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/.test(this.email)) {
        this.emailValid = true;
        return;
      }
      this.emailValid = false;
    },
  },
  data() {
    return {
      loaded: false,
      showLoading: false,
      showAllRequired: false,
      surveydata: {},
      email: "",
      institution: "",
      name: "",
      emailValid: false,
      submitted: false,
      categoryData: {},
    };
  },
  mounted() {
    window.setTimeout(() => {
      this.showLoading = true;
    }, 300);
    axios
      .get(baseurl + "getsurvey", { params: { code: this.$route.params.code } })
      .then((r) => {
        if ("success" in r.data && r.data.success === false) {
          this.$router.push("/");
          return;
        }
        this.loaded = true;
        this.surveydata = r.data;
        this.categoryData = JSON.parse(r.data.categoryData);
      })
      .catch(() => {
        this.$router.push("/");
      });
    pointsStore.resetStore();
  },
};
</script>

<style scoped>
.codetext {
  position: fixed;
  bottom: 0.3rem;
  right: 1rem;
  opacity: 0.5;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  cursor: default;
  user-select: none;
}
.mainContainer {
  max-width: 800px;
  margin-bottom: 4rem;
}
button {
  background-color: #007bff;
  border: none;
  border-radius: 1rem;
  cursor: pointer;
  margin-top: 2rem;
}
button > h2 {
  color: #ffffff;
  margin: 0.7rem 1rem 0.7rem 1rem;
}
.loadingContainer {
  max-width: 800px;
}
.delayshow {
  transition: 300ms;
}
.doshow {
  opacity: 1;
}
.dohide {
  opacity: 0;
}

.fillrequired {
  margin: 0.75rem 0;
  color: rgb(216, 18, 18);
}

input {
  border: 1px solid #555555;
  border-radius: 1rem;
  padding: 0.5rem 0.5rem;
  font-size: 1rem;
  font-weight: bold;
  height: 100%;
  width: min(100%, 300px);
}

.emailLabel {
  margin-bottom: 0.4rem;
  padding-left: 0.6rem;
}
.emailContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 2rem;
  padding-right: 2rem;
}

.requiredhighlight {
  color: rgb(216, 18, 18);
}
</style>
